import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStatusWaiting = createIcon({
  viewBox: '0 0 48 48',
  path: (
    <g fill="none" fillRule="evenodd">
      <g>
        <circle
          cx="24"
          cy="24"
          r="16.125"
          fill="#A5AAAF"
          stroke="#FFF"
          strokeWidth="3.75"
        />
        <circle cx="24" cy="24" r="17.25" stroke="#A5AAAF" strokeWidth="1.5" />
      </g>
      <path
        fill="#FFF"
        d="M24.107 28.286c.888 0 1.607.72 1.607 1.607s-.72 1.607-1.607 1.607-1.607-.72-1.607-1.607c0-.888.72-1.607 1.607-1.607zm0-11.786c.888 0 1.607.72 1.607 1.607v6.429c0 .887-.72 1.607-1.607 1.607s-1.607-.72-1.607-1.607v-6.429c0-.887.72-1.607 1.607-1.607z"
      />
    </g>
  ),
});

export default IconStatusWaiting;
